






import { Component, Vue } from 'vue-property-decorator';
import { app } from '@store/modules/app';
import { Toast } from 'types/layout';
import ToastMessage from '@components/layout/toast-message.vue';

@Component({
	components: {
		ToastMessage
	}
})
export default class ToastContainer extends Vue {
	get toasts(): Array<Toast> {
		return app.toasts;
	}

	dismiss(toast: Toast): void {
		app.DISMISS_TOAST(toast);
	}
}
